import Box from '@mui/material/Box'

import {
  DIRECT_INSTRUMENT_STATUS_FILTERS,
  type DirectInstrumentStatusFilter,
} from '@/features/campaigns/lib/quick-instrument-display'
import { AppShellHeaderSearch } from '@/shared/components/AppShell/AppShellHeaderSearch'

import { ADMIN_DASHBOARD_LAYOUT } from '../lib/admin-dashboard-layout'
import { DashboardStatusFilter } from './DashboardStatusFilter'

interface Props {
  search: string
  onSearchChange: (value: string) => void
  statusFilter: DirectInstrumentStatusFilter
  onStatusFilterChange: (value: DirectInstrumentStatusFilter) => void
}

export function DashboardDirectInstrumentsToolbar({
  search,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
}: Readonly<Props>) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { sm: 'center' },
        gap: { xs: 2, sm: ADMIN_DASHBOARD_LAYOUT.toolbarGap },
        flex: { xs: '1 1 100%', sm: '0 0 auto' },
      }}
    >
      <AppShellHeaderSearch
        value={search}
        onChange={onSearchChange}
        placeholder="Search by Instrument"
        testId="dashboard-direct-instruments-search"
        ariaLabel="Search by Instrument"
      />
      <DashboardStatusFilter
        value={statusFilter}
        onChange={onStatusFilterChange}
        options={DIRECT_INSTRUMENT_STATUS_FILTERS}
        filterWidth={ADMIN_DASHBOARD_LAYOUT.filterWidth}
        testId="dashboard-direct-instruments-status-filter"
      />
    </Box>
  )
}
